<template>
  <el-dialog
    :title="$t('addPrivilegeGroup.addRole')"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false">
    <el-form 
      ref="form" 
      :model="addPrivilegeGroupInfo" 
      label-width="120px"
      label-position="left">
      <el-alert
        v-if="addPrivilegeGroupInfo.errorInfo"
        :title="addPrivilegeGroupInfo.errorInfo"
        type="error"
        show-icon
        style="margin-bottom: 20px;">
      </el-alert>
      
      <el-form-item 
        :label="$t('addPrivilegeGroup.roleName')"
        prop="name"
        :rules="[
          { required: true, message: $t('addPrivilegeGroup.roleNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: $t('addPrivilegeGroup.roleNameLength'), trigger: 'blur' }
        ]">
        <el-input
          v-model="addPrivilegeGroupInfo.name"
          :placeholder="$t('addPrivilegeGroup.roleNamePlaceholder')">
        </el-input>
      </el-form-item>
      
      <el-form-item 
        :label="$t('addPrivilegeGroup.roleDesc')"
        prop="description">
        <el-input
          type="textarea"
          :rows="3"
          v-model="addPrivilegeGroupInfo.description"
          :placeholder="$t('addPrivilegeGroup.roleDescPlaceholder')"
          maxlength="200"
          show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button 
        type="primary" 
        @click="saveAddPrivilegeGroup"
        :loading="loading">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { savePrivilegeGroup } from '@/api/privilege/privilegeApi'

export default {
  name: 'AddPrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      addPrivilegeGroupInfo: {
        name: '',
        description: '',
        errorInfo: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    async saveAddPrivilegeGroup() {
      try {
        this.loading = true
        await this.$refs.form.validate()
        
        const res = await savePrivilegeGroup(this.addPrivilegeGroupInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('addPrivilegeGroup.addSuccess'))
          this.dialogVisible = false
          this.$emit('privilegeGroup_loadPrivilegeGroup')
          this.$emit('roleDiv_loadRole')
        } else {
          this.addPrivilegeGroupInfo.errorInfo = res.msg
        }
      } catch (error) {
        console.error('Failed to save privilege group:', error)
        this.addPrivilegeGroupInfo.errorInfo = error.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 22px;
}
</style>